import { isEmpty } from 'lodash'

import createComputed from 'modules/core/hooks/createComputed'
import { matchText } from 'modules/core/lib/stringUtils'
import users from 'modules/core/store/collections/users'

import type Employee from 'modules/employees/store/models/Employee'
import { ImportData } from 'modules/payroll_bundle/lib/PayrollResultContext'

const filterItemsByEmployees = (filteredEmployees: Employee[], items: ImportData[]) => {
  const filteredEmployeeIds = new Set(filteredEmployees.map((employee) => employee.id))
  return items.filter((item) => {
    return !item.employee_id || filteredEmployeeIds.has(item.employee_id)
  })
}

export const useEmployeeSearchFilter = createComputed(
  (search: string, filteredEmployees: Employee[], items: ImportData[]) => {
    const filteredItems = filterItemsByEmployees(filteredEmployees, items)

    if (isEmpty(search)) return filteredItems

    const filteredEmployeesBySearch = filteredEmployees.filter((employee) => {
      const user = users.get(employee.attributes.access_id)
      return user && matchText(search, user.fullName())
    })

    const itemsByExcelName = items.filter((item) => {
      return matchText(search, item.full_name)
    })

    const itemsByFactorialName = filterItemsByEmployees(filteredEmployeesBySearch, items)

    return [...new Set([...itemsByExcelName, ...itemsByFactorialName])] // Is converted as a set to remove duplicated items
  }
)
